import { BaseClient } from './BaseClient';
export class MarketplaceAPI extends BaseClient {
    async signWertMessageAndCreateSession(body, identity) {
        try {
            const response = await this.fetch('/v1/wert/sign', {
                method: 'POST',
                identity,
                body: JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response;
        }
        catch (error) {
            throw new Error(error.message);
        }
    }
    /**
     * Given the order id, returns relevant data related to status changes (status & tx hash).
     *
     * @param orderId - Transak Order ID.
     */
    async getOrder(orderId, identity) {
        return await this.fetch(`/v1/transak/orders/${orderId}`, {
            identity
        });
    }
}
//# sourceMappingURL=marketplaceApi.js.map